import React from "react";
import { NumberTicker } from "../NumberTicker";

interface IWhyChooseSolutions {
  onOpenModal: () => void;
}

const WhyChooseSolutions: React.FC<IWhyChooseSolutions> = ({ onOpenModal }) => {
  return (
    <div>
      <div className="flex items-center">
        <h3 className="text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3.4rem]">
          Why choose our Recruitment & Staffing Solutions?
        </h3>
      </div>
      <div>
        <p className="pt-8 max-w-[65rem] font-light md:text-lg xl:text-[1.6rem]">
          We take pride in developing products that have set their goals to
          improve the world and change the lives of millions of people.
        </p>
      </div>
      <div
        className="flex flex-col relative text-[#10124E] gap-10 md:gap-16 lg:gap-32 md:flex-row my-10 md:my-20 xl:my-24 rounded-r-2xl"
        style={{
          backgroundImage: "url('/consulting/bg.svg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className=" items-center justify-center absolute hidden md:flex md:-bottom-[4.7rem] xl:left-12 lg:-bottom-[5.1rem] xl:-bottom-[5.1rem]">
          <div className="">
            <div className="max-w-[20rem] lg:max-w-[22rem] flex justify-end">
              <img
                src="/consulting/black-man.png"
                alt=""
                className="w-full h-full"
              />
            </div>
          </div>
        </div>
        <div className="flex-1 flex-col gap-5 p-5 justify-center items-center w-full md:ml-[16rem] lg:ml-[20rem] xl:ml-[25rem]">
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-10 xl:gap-20 md:pt-10">
            <div className="p-5">
              <h4 className="text-3xl xl:text-6xl">
                <NumberTicker value={12000} />+
              </h4>
              <p className="xl:text-[1.6rem] pt-3 xl:pr-4">
                Successful placements in last 10 years
              </p>
            </div>
            <div className="p-5">
              <h4 className="text-3xl xl:text-6xl">
                <NumberTicker value={200} />+
              </h4>
              <p className="xl:text-[1.6rem] pt-3 max-w-72">
                Organizations served nation-wide
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 p-5">
            <div className="md:border-r-[1.2px] md:border-[#4f505b] xl:pr-1">
              <h4 className="text-lg md:text-xl xl:text-4xl">
                <NumberTicker value={10000} />+
              </h4>
              <p className="text-sm xl:text-lg leading-snug pt-2">
                Pre-screened professionals across diverse industries.
              </p>
            </div>
            <div className="md:border-r-[1.2px] md:border-[#10124E]">
              <h4 className="text-lg md:text-xl xl:text-4xl">
                <NumberTicker value={300} />+
              </h4>
              <p className="text-sm xl:text-lg leading-snug pt-2">
                Human Resource Professionals
              </p>
            </div>
            <div className=" border-neutral-500">
              <h4 className="text-lg md:text-xl xl:text-4xl">
                <NumberTicker value={13} />+
              </h4>
              <p className="text-sm xl:text-lg leading-snug pt-2">
                Industries we source talent to.
              </p>
            </div>
          </div>
        </div>
        <div className="sm:hidden flex justify-center items-center">
          <div className="max-w-[20rem] flex justify-end -mb-[4.5rem]">
            <img src="/consulting/black-man.png" alt="" className="w-full" />
          </div>
        </div>
      </div>
      <div className="w-full py-4 flex justify-center items-center px-7 md:px-5 lg:px-20">
        <div className="grid md:grid-cols-2 gap-20 xl:px-8">
          <LookingForProfessional onOpenModal={onOpenModal} />
          <LookingForOpportunity onOpenModal={onOpenModal} />
        </div>
      </div>
    </div>
  );
};

const LookingForProfessional: React.FC<IWhyChooseSolutions> = ({
  onOpenModal,
}) => {
  return (
    <div className="shadow-2xl">
      <div>
        <img
          src="/consulting/organization.jpg"
          alt=""
          className="w-full max-h-80 object-cover object-center"
        />
      </div>
      <div className="p-10 py-6 flex flex-col gap-2">
        <p className="text-xl font-normal xl:text-[1.8rem]">
          Looking for Professionals
        </p>
        <p className="font-bold text-lg xl:text-3xl pt-1">
          For Your Organization
        </p>
        <p className="text-xs py-3 xl:text-[0.96rem] leading-normal font-medium">
          Looking for top-tier talent to scale your business? Dream Weavers
          provides end-to-end recruitment solutions to help you find the perfect
          fit.
        </p>
        <p className="font-bold text-sm xl:text-[1rem] pt-2">What We Offer</p>
        <div className="flex flex-col gap-1 mx-2">
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>Comprehensive talent acquisition.</p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>Industry-specific recruitment expertise.</p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>Quick turnaround time for sourcing.</p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>Dedicated account management support.</p>
          </div>
        </div>
        <div className="py-6">
          {/* todo: change link here */}
          <div className="text-xs  md:text-sm xl:text-2xl">
            <button
              onClick={onOpenModal}
              className="px-5 py-3 rounded-full custom-hover text-white bg-[#0040D8]"
            >
              Hire Top Talent Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const LookingForOpportunity: React.FC<IWhyChooseSolutions> = ({
  onOpenModal,
}) => {
  return (
    <div className="shadow-2xl ">
      <div>
        <img
          src="/consulting/professional.jpg"
          alt=""
          className="max-h-80 w-full bg-center"
        />
      </div>
      <div className="flex flex-col p-10 py-6">
        <div className="flex flex-col gap-2">
          <p className="text-xl font-normal xl:text-[1.8rem]">
            Looking for Opportunity
          </p>
          <p className="font-bold text-lg xl:text-3xl pt-1">
            As a Professional
          </p>
          <p className="text-xs py-3 xl:text-[0.96rem] leading-normal font-medium">
            Ready to take the next big step in your career? Dream Weavers
            connects skilled professionals like you with top organizations
            across India.
          </p>
          <p className="font-bold text-sm xl:text-[1rem] pt-2">Why Join Us?</p>
          <div className="flex flex-col gap-1 mx-2">
            <div className="flex gap-1 text-xs xl:text-base">
              <div>&#x2022;</div>
              <p>Access to exclusive job opportunities.</p>
            </div>
            <div className="flex gap-1 text-xs xl:text-base">
              <div>&#x2022;</div>
              <p>Free career counseling and resume support.</p>
            </div>
            <div className="flex gap-1 text-xs xl:text-base">
              <div>&#x2022;</div>
              <p>Placement in renowned companies and organizations.</p>
            </div>
          </div>
        </div>
        <div className="pt-[2.4rem]">
          {/* todo: change link here */}
          <div className="text-xs md:text-sm xl:text-2xl">
            <button
              onClick={onOpenModal}
              className="px-5 py-3 rounded-full custom-hover text-white bg-[#0040D8]"
            >
              Apply as a Candidate Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseSolutions;
